import Image from "@components/Image";
import SearchBar from "@components/SearchBar";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import LogoutIcon from "@mui/icons-material/Logout";
import MapIcon from "@mui/icons-material/Map";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import QRCodePopup from "./components/QRCodePopup";
import useAuth from "@/hooks/useAuth";
import useUsers from "@/hooks/useUsers";
import { hasPermission } from "@/utils/functions/permission";
import { Permission } from "@/utils/constants/permission";
import { authenticationLocalStorage } from "@/utils/constants/localStorage";

const Header = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { supervisor } = useUsers();

  const isAdmin = authenticationLocalStorage.loggedUser?.role === "ADMIN";
  //const isSup = authenticationLocalStorage.loggedUser?.role === "SUPERVISOR";

  const ownCompanyId = authenticationLocalStorage.loggedUser?.companyId;

  const [src, setSrc] = useState("logo");
  const [isQRCodePopupOpen, setIsQRCodePopupOpen] = useState(false);

  const changeLogo = () => {
    setSrc((prev) => (prev === "logo" ? "animated-logo" : "logo"));
  };

  const goToConfigurationPage = () => navigate("/configuration/grammar");
  const goToStatusPage = () => navigate("/status");

  const goToMapPage = () => navigate("/");

  const openQRCodeGenerationPopUp = () => {
    setIsQRCodePopupOpen(true);
  };

  const isMapPage =
    window.location.pathname === `${process.env.PUBLIC_URL ?? ""}/` ||
    window.location.pathname === `${process.env.PUBLIC_URL ?? ""}/index.html`;

  return (
    <>
      <Stack
        direction="row"
        height="100%"
        width="100%"
        sx={{ background: (theme) => theme.palette.primary.main }}
        justifyContent="space-between"
        alignItems="center">
        <Stack direction="row" spacing={1} alignItems="center" ml="20px">
          <Box onClick={changeLogo}>
            <Image source={`images/${src}.svg`} />
          </Box>

          <Typography variant="h4" sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }}>
            PERIPHERAL
          </Typography>
          {isMapPage ? (
            <Box ml={2}>
              <SearchBar />
            </Box>
          ) : null}
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center" mr="20px">
          {isAdmin && (
            <Tooltip title="Administration">
              <IconButton onClick={() => navigate("/admin")}>
                <AdminPanelSettingsIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
              </IconButton>
            </Tooltip>
          )}
          {supervisor != null && hasPermission(Permission.ADMINISTRATION, supervisor) && !isAdmin && (
            <Tooltip title="Administration">
              <IconButton onClick={() => navigate(`/admin/company/${ownCompanyId}`)}>
                <AdminPanelSettingsIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
              </IconButton>
            </Tooltip>
          )}
          {supervisor != null && hasPermission(Permission.QR_CODE, supervisor) && (
            <Tooltip title="Générer un QRCode">
              <IconButton onClick={openQRCodeGenerationPopUp}>
                <QrCodeIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
              </IconButton>
            </Tooltip>
          )}
          {supervisor != null && hasPermission(Permission.CONFIGURATION, supervisor) && (
            <Tooltip title="Configuration">
              <IconButton onClick={goToConfigurationPage}>
                <EditIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
              </IconButton>
            </Tooltip>
          )}
          {supervisor != null && hasPermission(Permission.STATUS, supervisor) && (
            <Tooltip title="Consulter les statuts">
              <IconButton onClick={goToStatusPage}>
                <InfoIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="Carte interactive">
            <IconButton onClick={goToMapPage}>
              <MapIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Se déconnecter">
            <IconButton onClick={logout}>
              <LogoutIcon sx={{ color: (theme: ThemeType) => theme.palette.primary.contrastText }} />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
      {isQRCodePopupOpen && createPortal(<QRCodePopup onClose={() => setIsQRCodePopupOpen(false)} />, document.body)}
    </>
  );
};

export default Header;
